<template>
  <div class="schedule_detail">
    <dl class="current_match_info" v-show="matchInfo.match_id > 0">
      <dd class="left">
        <strong>{{ matchInfo.home }}</strong>
        <span class="logo">
          <img
            v-if="matchInfo.home_logo.length > 0"
            :src="matchInfo.home_logo"
          />
          <img
            v-else
            :src="
              require(`./img/${ballType == 1 ? 'football' : 'basketball'}.png`)
            "
          />
        </span>
        <span class="score">{{ matchInfo.home_score }}</span>
      </dd>
      <dt>
        <div :class="`name tags-letter-${matchInfo.first_letter}`">
          {{ matchInfo.comp_short_zh }}
        </div>
        <p>{{ dateFormat(matchInfo.match_time * 1000, "yyyy/MM/dd hh:mm") }}</p>
        <h3 v-if="ballType == 1 && matchInfo.match_status == 1">
          {{ matchInfo.time_played }}
        </h3>
        <h3 v-else>{{ matchInfo.match_detail_status }}</h3>
        <div class="half_corner" v-if="matchInfo.sport_id == 1">
          <span>{{ getHalfScore }}</span>
          <span>{{ getCornerScore }}</span>
        </div>
      </dt>
      <dd>
        <span class="score">{{ matchInfo.away_score }}</span>
        <span class="logo">
          <img
            v-if="matchInfo.away_logo.length > 0"
            :src="matchInfo.away_logo"
          />
          <img
            v-else
            :src="
              require(`./img/${ballType == 1 ? 'football' : 'basketball'}.png`)
            "
          />
        </span>
        <strong>{{ matchInfo.away }}</strong>
      </dd>
    </dl>

    <div class="body_left">
      <div class="iframe-box">
        <!-- <img :src="require(`./img/${ballType == 1 ? 'football_bg' : 'basketball_bg'}.png`)" style="width: 100%" /> -->
        <iframe
          id="ballIframe"
          :src="AnimationUrl"
          :style="'transform: scale(' + iframe_zoom_rate + ')'"
        ></iframe>
      </div>
      <!--足球选项卡及内容块-->
      <div v-show="ballType == 1">
        <ul class="option_tags">
          <li
            @click="getFBallContent(1)"
            :class="fooballTag == 1 ? 'active' : ''"
          >
            {{ $t("pc.textLiving") }}
          </li>
          <li
            @click="getFBallContent(2)"
            :class="fooballTag == 2 ? 'active' : ''"
          >
            {{ $t("pc.importantEvent") }}
          </li>
          <li
            @click="getFBallContent(3)"
            :class="fooballTag == 3 ? 'active' : ''"
          >
            {{ $t("match.technology") }}
          </li>
          <li
            @click="getFBallContent(4)"
            :class="fooballTag == 4 ? 'active' : ''"
          >
            {{ $t("pc.matchTeam") }}
          </li>
        </ul>
        <div class="tags_content">
          <!--文字直播-->
          <football-text
            v-show="fooballTag == 1"
            ref="fballContent1"
          ></football-text>

          <!--关键事件-->
          <football-important
            v-show="fooballTag == 2"
            :matchInfo="matchInfo"
            ref="fballContent2"
            :fballTypes="fballTypes"
          ></football-important>

          <!--技术统计-->
          <football-counter
            v-show="fooballTag == 3"
            :matchInfo="matchInfo"
            ref="fballContent3"
            :fballTypes="fballTypes"
          ></football-counter>

          <!--球队阵容-->
          <football-users
            v-show="fooballTag == 4"
            :matchInfo="matchInfo"
            ref="fballContent4"
          ></football-users>
        </div>
      </div>

      <!--篮球选项卡及内容块-->
      <div v-show="ballType == 2">
        <ul class="option_tags">
          <li
            @click="getBBallContent(1)"
            :class="basketballTag == 1 ? 'active' : ''"
          >
            {{ $t("pc.textLiving") }}
          </li>
          <li
            @click="getBBallContent(2)"
            :class="basketballTag == 2 ? 'active' : ''"
          >
            {{ $t("pc.teamScrore") }}
          </li>
          <li
            @click="getBBallContent(3)"
            :class="basketballTag == 3 ? 'active' : ''"
          >
            {{ $t("match.technology") }}
          </li>
        </ul>
        <div class="tags_content">
          <!--文字直播-->
          <basketball-text
            v-show="basketballTag == 1"
            ref="bballContent1"
          ></basketball-text>

          <!--球队比分-->
          <basketball-scores
            v-show="basketballTag == 2"
            ref="bballContent2"
            :matchInfo="matchInfo"
          ></basketball-scores>

          <!--技术统计-->
          <basketball-counter
            v-show="basketballTag == 3"
            ref="bballContent3"
            :matchInfo="matchInfo"
          ></basketball-counter>
        </div>
      </div>
    </div>
    <div class="body_right">
      <dl class="notice_scroll">
        <dt><img src="./img/icon_notice.png" /></dt>
        <dd>
          <router-link to="#"
            >全程高清直播尽在猎鹰体育！更有众多主播专业解说</router-link
          >
        </dd>
        <dt class="arrow"><img src="./img/icon_arrow_down.png" /></dt>
      </dl>
      <ul class="option_title">
        <li class="active">主播</li>
        <li v-show="false">鹰眼</li>
      </ul>
      <anchor-list></anchor-list>
      <div class="option_content" v-show="false">
        <!--鹰眼预留内容块-->
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";
import TIM from "tim-js-sdk";
import { tim, timJoinGroup } from "@/util/tim";
import { format } from "@/util/time";

//足球相关组件
import FootballText from "@/components/match-recommend/fball-text";
import FootballImportant from "@/components/match-recommend/fball-important";
import FootballCounter from "@/components/match-recommend/fball-counter";
import FootballUsers from "@/components/match-recommend/fball-users";
//篮球相关组件
import BasketballText from "@/components/match-recommend/bball-text";
import BasketballScores from "@/components/match-recommend/bball-scores";
import BasketballCounter from "@/components/match-recommend/bball-counter";
//右侧主播列表组件
import AnchorList from "@/components/match-recommend/anchor_list";
import { Minimatch } from "minimatch";

export default {
  name: "scheduleDetail",
  // metaInfo() {
  //   return {
  //     title: "Xôi Lạc TV - Trực Tiếp Bóng Đá Hôm Nay | Xem Bóng Đá Miễn Phí",
  //     meta: [
  //       {
  //         name: "keywords",
  //         content:
  //           "xoilac, xoilac tv, xôi lạc trực tiếp bóng đá hôm nay, truc tiep bong da, xem bong da truc tuyen",
  //       },
  //     ],
  //   };
  // },
  data() {
    return {
      //当前球类的类型:1=足球，2=篮球
      ballType: 1,
      //当前赛事ID
      matchId: 0,
      //赛事基本信息
      matchInfo: {},
      //定义日期函数的处理方法
      dateFormat: format,
      //动画直播的iframe地址
      AnimationUrl: "",
      //iframe被强行拉大的比例值
      iframe_zoom_rate: 1.2,
      //足球内容块选项卡及内容选中的标识
      fooballTag: 1,
      //篮球内容块选项卡及内容选中的标识
      basketballTag: 1,
      //足球类型识别
      fballTypes: {},
      //检测modify回调数据的timer
      timerCheckModify: null,
      //检测recevied回调数据的timer
      timerCheckRecevied: null,
    };
  },
  components: {
    FootballText,
    FootballImportant,
    FootballCounter,
    FootballUsers,
    BasketballText,
    BasketballScores,
    BasketballCounter,
    AnchorList,
  },
  created() {
    //获取地址栏参数，并重置data中的部分参数值
    const getParams = this.$route.params;
    this.ballType = parseInt(getParams.sportId);
    this.matchId = parseInt(getParams.id);
    //给足球type赋值
    const football_types = {};
    football_types[1] = {
      name: "进球",
      icon: 1,
    };
    football_types[2] = {
      name: "角球",
      icon: 8,
    };
    football_types[3] = {
      name: "黄牌",
      icon: 9,
    };
    football_types[4] = {
      name: "红牌",
      icon: 10,
    };
    football_types[5] = {
      name: "越位",
      icon: 14,
    };
    football_types[6] = {
      name: "任意球",
    };
    football_types[7] = {
      name: "球门球",
    };
    football_types[8] = {
      name: "点球",
      icon: 4,
    };
    football_types[9] = {
      name: "换人",
      icon: 11,
    };
    football_types[10] = {
      name: "比赛开始",
    };
    football_types[11] = {
      name: "中场",
    };
    football_types[12] = {
      name: "结束",
    };
    football_types[13] = {
      name: "半场比分",
    };
    football_types[15] = {
      name: "两黄变红",
      icon: 12,
    };
    football_types[16] = {
      name: "点球未进",
      icon: 5,
    };
    football_types[17] = {
      name: "乌龙球",
      icon: 6,
    };
    football_types[18] = {
      name: "助攻",
      icon: 7,
    };
    football_types[19] = {
      name: "伤停补时",
    };
    football_types[21] = {
      name: "射正",
      icon: 2,
    };
    football_types[22] = {
      name: "射偏",
      icon: 3,
    };
    football_types[23] = {
      name: "进攻",
    };
    football_types[24] = {
      name: "危险进攻",
    };
    football_types[25] = {
      name: "控球率",
    };
    football_types[26] = {
      name: "加时赛结束",
    };
    football_types[27] = {
      name: "点球大战结束",
    };
    football_types[28] = {
      name: "VAR(视频助理裁判)",
      icon: 13,
    };
    football_types[29] = {
      name: "点球(点球大战)",
    };
    football_types[30] = {
      name: "点球未进(点球大战)",
    };
    this.fballTypes = football_types;
  },
  watch: {
    async isTimReady(tim_link_status) {
      // console.log('tim连通状态watch：',tim_link_status)
      //如果tim连接准备好了，就发送一次默认请求
      if (tim_link_status) {
        await this.onSdkReady();
      }
    },
  },
  computed: {
    ...mapState(["isTimReady", "userInfo", "appConfig", "matchDetailData"]),

    //足球：半比分
    getHalfScore() {
      if (this.matchInfo.match_status == 2) {
        return "";
      }
      let half_score = "半";
      if (this.matchInfo.f_home_score == null) {
        half_score += "0-";
      } else {
        half_score += this.matchInfo.f_home_score.half_score + "-";
      }
      if (this.matchInfo.f_away_score == null) {
        half_score += "0";
      } else {
        half_score += this.matchInfo.f_away_score.half_score;
      }
      return half_score;
    },
    //足球：角球比分
    getCornerScore() {
      if (this.matchInfo.match_status == 2) {
        return "";
      }
      let corner_score = "角";
      if (this.matchInfo.f_home_score == null) {
        corner_score += "0-";
      } else {
        corner_score += this.matchInfo.f_home_score.corner_kick + "-";
      }
      if (this.matchInfo.f_away_score == null) {
        corner_score += "0";
      } else {
        corner_score += this.matchInfo.f_away_score.corner_kick;
      }
      return corner_score;
    },
  },
  async mounted() {
    //根据地址栏信息实始化页面载入内容
    const getParmas = this.$route.query;
    //页面上不同的面板开关标识
    let nav_tag = 1;
    if (getParmas.navTag) {
      nav_tag = parseInt(getParmas.navTag);
    }
    this.initPage(nav_tag);
    //取赛事基本信息
    this.getMatchInfo();
    //取赛事动画的IFRAME
    this.getMatchAnimation();

    // console.log('tim连通状态mounted：',this.isTimReady)
    if (this.isTimReady) {
      await this.onSdkReady();
    }

    //读取modify事件中的数据,超过30秒就不再获取
    let timer_modify = 0;
    this.timerCheckModify = setInterval(() => {
      this.$store.state.matchDetailData.modified.forEach((item) => {
        this.onModified(item);
      });
      timer_modify++;
      if (timer_modify >= 20) {
        // console.log("modify拿到的数据：", this.$store.state.matchDetailData.modified);
        clearInterval(this.timerCheckModify);
      }
      // console.log('计数器：', timer_modify);
    }, 1000);

    //读取received事件中的数据
    this.timerCheckRecevied = setInterval(() => {
      const obj = this.$store.state.matchDetailData.received;
      for (let key in obj) {
        if (obj[key].length > 0) {
          this.onReceived(obj[key]);
        }
      }
    }, 1000);
  },
  beforeDestroy() {
    //离开页面前，清空缓存的旧值
    this.$store.commit("clearMatchLiveData");
    // document.getElementById("ballIframe").removeEventListener("load", () => {
    //   this.isIframeLoad = false;
    // });
  },
  destroyed() {
    clearInterval(this.timerCheckModify);
    //销毁消息回调数据识别的定时器
    clearInterval(this.timerCheckRecevied);
    //离开页面时，清理一次state中的数据
  },

  methods: {
    ...mapMutations([
      "changeUserInfo",
      "toggleLogin",
      "changeLoginType",
      "changeConfig",
    ]),

    /**
     * 页面信息初始化
     */
    initPage(nav_tag) {
      //根据当前参数处理不同的业务逻辑
      if (this.ballType == 1) {
        this.fooballTag = nav_tag;
      } else {
        this.basketballTag = nav_tag;
      }
      this.resetUrl(nav_tag);
    },

    /**
     * 重置地址栏参数，防止刷新后失去当前定位的选项
     * @param {Int} navTag 页面不同面板标识符
     */
    resetUrl(navTag) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      let url = "";
      if (this.ballType == 1) {
        if (typeof navTag == "undefined") {
          url = origin + path + "?navTag=" + this.fooballTag;
        } else {
          url = origin + path + "?navTag=" + navTag;
        }
      }
      if (this.ballType == 2) {
        if (typeof navTag == "undefined") {
          url = origin + path + "?navTag=" + this.basketballTag;
        } else {
          url = origin + path + "?navTag=" + navTag;
        }
      }

      window.history.pushState("", "", url);
      //将URL返回给需要强行跳转的地方调用
      return url;
    },

    /**
     * 获取赛事基本信息
     */
    getMatchInfo() {
      post({
        url: "/api/match/getMatchById",
        data: {
          match_id: this.matchId,
        },
      }).then((res) => {
        if (res.status == 200 && res.data.status == 0) {
          this.matchInfo = res.data.data;
          console.log("matchinfo:", this.matchInfo);
        }
        console.log("赛事基本信息：", res);
      });
    },

    //取iframe要用的数据
    getMatchAnimation() {
      post({
        url: "/api/live/official_live",
        data: {
          match_id: this.matchId,
          pull_url: "",
          room_id: 0,
          title: "",
        },
      })
        .then((res) => {
          // console.log("动画直播IFRAME:", res);
          this.AnimationUrl = res.data.data.pull_url;
        })
        .catch((err) => {
          console.log("赛事动画直播界面请求失败～", err);
        });
    },

    /**
     * SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能
     */
    onSdkReady() {
      let payloads_arr = [];
      //以下是足球所需要的触发的请求
      if (this.ballType == 1) {
        //文字直播，关键事件和文字直播使用的是同一个type，回发回来的数据中，main=1是关键事件
        payloads_arr.push(
          JSON.stringify({
            type: "textLive",
            groupId: this.matchId,
            lang: "vi",
          })
        );

        /* //统计数据
        payloads_arr.push(JSON.stringify({ type: "matchLive", groupId: this.matchId, lang : "vi" }));/**/

        //足球阵容,足球阵容没有回发recevied事件
        //  payloads_arr.push(JSON.stringify({ type: "lineupLive-1", groupId: this.matchId, lang : "vi" }));
      }

      //以下是篮球所需要触发的请求
      if (this.ballType == 2) {
        //文字直播
        payloads_arr.push(
          JSON.stringify({
            type: "textLive",
            groupId: this.matchId,
            lang: "vi",
          })
        );
        //球队比分+技术统计的数据
        payloads_arr.push(
          JSON.stringify({
            type: "matchLive",
            groupId: this.matchId,
            lang: "vi",
          })
        );
      }

      //循环请求一次，触发modified事件
      payloads_arr.forEach((item, index) => {
        let message = tim.createCustomMessage({
          to: "admin",
          conversationType: TIM.TYPES.CONV_C2C,
          payload: {
            data: item,
          },
        });
        let promise = tim.sendMessage(message);
        promise
          .then((imResponse) => {
            if (imResponse.code == 0) {
              // 发送成功
              console.log(`第${index}条发送成功:`, imResponse);
            }
          })
          .catch((imError) => {
            // 发送失败
            // console.warn(`第${index}条发送失败:`, imError);
          });
      });

      //加入群组，才能触发recevied事件回发
      //赛事ID作为房间号，没有主播，所以第二个参数用赛事中文名称替代，做为主播昵称使用
      console.log("ball type:", this.ballType);
      timJoinGroup(this.ballType, this.matchInfo.comp_short_zh);
    },

    /**
     * 触发修改动作
     * @param {object} event 事件响应对象
     */
    onModified(event) {
      let payload_data = event.data[0].payload.data;
      console.log("modified接收到的数据:", payload_data);
      //足球
      if (this.ballType == 1) {
        //文字直播和关键事件
        if (payload_data.indexOf("textLive") != -1) {
          this.$refs.fballContent1.runData(payload_data);
          this.$refs.fballContent2.runData(payload_data);
        }
        //技术统计

        if (
          payload_data.indexOf("scoreLive") != -1 ||
          payload_data.indexOf("statsLive") != -1
        ) {
          console.log("fballContent3:", payload_data);
          this.$refs.fballContent3.fbCounterRunData(payload_data);
        }
        //足队阵容
        if (payload_data.indexOf("lineupLive") != -1) {
          console.log("fballContent4:", payload_data);
          this.$refs.fballContent4.onTimModified(payload_data);
        }
      } //end 足球

      //篮球
      if (this.ballType == 2) {
        //文字直播
        if (payload_data.indexOf("textLive") != -1) {
          this.$refs.bballContent1.runData(payload_data);
        }
        //球队比分+技术统计
        if (
          payload_data.indexOf("scoreLive") != -1 ||
          payload_data.indexOf("statsLive") != -1
        ) {
          this.$refs.bballContent2.runData(payload_data);
          this.$refs.bballContent3.runData(payload_data);
        }
      }
    },

    /**
     * 后台主动推送过来的数据
     * @param {object} get_data 经过加工后的数据
     */
    onReceived(get_data) {
      // console.log("received接收到的数据:", get_data);
      let new_data = "";
      //足球
      if (this.ballType == 1) {
        if (get_data.indexOf("textLive") != -1) {
          //将数据构造成和modify接收到时一样，方便内部业务统一化处理
          new_data = `"[${get_data}]"`;
          this.$refs.fballContent1.runData(new_data);
          this.$refs.fballContent2.runData(new_data);
        }
        //红黄牌
        if (
          get_data.indexOf("scoreLive") != -1 ||
          get_data.indexOf("statsLive") != -1
        ) {
          //将数据构造成和modify接收到时一样，方便内部业务统一化处理
          if (get_data.indexOf("scoreLive") == -1) {
            new_data = `"[{"type":"not"},${get_data}]"`;
          } else {
            new_data = `"[${get_data}]"`;
          }
          this.$refs.fballContent3.fbCounterRunData(new_data);
        }
      }
      //篮球
      if (this.ballType == 2) {
        if (get_data.indexOf("textLive") != -1) {
          //将数据构造成和modify接收到时一样，方便内部业务统一化处理
          new_data = `"[${get_data}]"`;
          this.$refs.bballContent1.runData(new_data);
        }
        //比分+技术统计
        if (
          get_data.indexOf("scoreLive") != -1 ||
          get_data.indexOf("statsLive") != -1
        ) {
          //将数据构造成和modify接收到时一样，方便内部业务统一化处理
          if (get_data.indexOf("scoreLive") == -1) {
            new_data = `"[{"type":"not"},${get_data}]"`;
          } else {
            new_data = `"[${get_data}]"`;
          }
          this.$refs.bballContent2.runData(new_data);
          this.$refs.bballContent3.runData(new_data);
        }
      }
    },

    //当发生错误时
    timOnError(e) {
      // this.$message.error("数据连接出错，给您造成的不便敬请谅解～");
      console.log(e, "timOnError");
    },

    //点击足球内容块的选项卡时触发的切换动作
    getFBallContent(tag) {
      this.fooballTag = tag;
      this.resetUrl();
    },

    //点击篮球内容块的选项卡时触发的切换动作
    getBBallContent(tag) {
      this.basketballTag = tag;
      this.resetUrl();
    },

    /**
     * unioncode解码
     * @param {string} str 要解码的字符串
     */
    decodeUnicode(str) {
      str = str.replace(/\\\u/g, "%u");
      return unescape(str);
    },

    /**
     * 将字符串转换为数组
     * @param {int} num 数值
     * @param {boolean} remove_decimal 是否移除小数，默认false,遇到小数直接舍去，不是四舍五入
     */
    numToArray(num, remove_decimal) {
      let rs = arguments[1] ? arguments[1] : false;
      if (typeof num == "number") {
        if (rs === true) {
          let num_arr = num.toString().split(".");
          return num_arr[0].toString().split("");
        } else {
          return num.toString().split("");
        }
      } else {
        return [0];
      }
    },

    /**
     * 两数相加并取出X在加的结果中的占比
     * 注：总是返回X的占比值。主客队，如果要计算谁的占比，则谁就放在X位置上
     * @param {int} x 分值1，此值为除数
     * @param {int} y 分值2，此值为被除数
     */
    getRatio(x, y) {
      if (x + y == 0) {
        return 0;
      } else {
        return Math.ceil((x / (x + y)) * 100);
      }
    },
  },
};
</script>
<style lang="scss">
.schedule_detail {
  clear: both;
  width: 14rem;
  padding-top: 0.76rem;
  padding-bottom: 30px;
  margin: 0px auto;

  /*面板页面的两个球队的信息比对效果*/
  .team_name_logo {
    display: flex;
    justify-content: space-between;
    clear: both;
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0.2rem 0.5rem;
    margin-top: 20px;

    li {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .logo {
        display: block;
        float: left;
        width: 64px;
        height: 64px;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 50px;
        border: 1px solid #dcdcdc;
        padding: 5px;

        img {
          display: block;
          height: 100%;
          margin: 0 auto;
        }
      }

      strong {
        display: block;
        float: left;
        width: auto;
        height: 100%;
        line-height: 64px;
        overflow: hidden;
        padding: 0px 15px;
        font-size: 0.16rem;
        color: #333;
      }
    }

    li.icon_compare {
      flex-shrink: 0;
      width: 2rem;
      line-height: 64px;
      overflow: hidden;
      font-size: 0.4rem;
      font-family: "DIN Altern, Arial";
      color: #333;
      font-weight: 700;
      text-align: center;
    }

    li.last {
      strong,
      .logo {
        float: right;
      }
    }
  }

  //页眉的两个队的比赛信息横条
  .current_match_info {
    display: flex;
    justify-content: center;
    align-items: center;
    clear: both;
    width: 100%;
    height: 1.6rem;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0.05rem;
    margin-bottom: 0.1rem;
    padding: 0.2rem;

    dt {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 3.2rem;
      height: 100%;
      overflow: hidden;
      text-align: center;
      font-size: 0.14rem;
      color: #666;

      .name {
        display: block;
        width: auto;
        height: 0.24rem;
        line-height: 0.24rem;
        overflow: hidden;
        background-color: #eee;
        border-radius: 0.02rem;
        margin: 0.05rem auto;
        padding: 0px 10px;
      }

      p,
      h3 {
        clear: both;
        width: 100%;
        height: 0.25rem;
        line-height: 0.25rem;
        overflow: hidden;
      }

      h3 {
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.2rem;
        color: #db6372;
        font-family: "DIN Alternate";
      }

      .half_corner {
        display: flex;
        justify-content: center;
        clear: both;
        width: 100%;
        height: 0.25rem;
        line-height: 0.25rem;
        overflow: hidden;

        span {
          padding: 0px 10px;
        }
      }
    }

    dd {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      color: #333;

      strong {
        display: block;
        float: left;
        width: 100%;
        height: 0.64rem;
        line-height: 0.64rem;
        overflow: hidden;
        font-size: 0.16rem;
      }

      .score {
        flex-shrink: 0;
        display: block;
        float: left;
        width: 0.8rem;
        height: 0.64rem;
        line-height: 0.64rem;
        overflow: hidden;
        font-size: 0.4rem;
        font-weight: bold;
      }

      .logo {
        flex-shrink: 0;
        display: block;
        float: left;
        width: 0.64rem;
        height: 0.64rem;
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #dcdcdc;
        border-radius: 0.5rem;
        background-color: #fff;
        margin: 0px 0.15rem;
        padding: 0.05rem;

        img {
          display: block;
          height: 100%;
          margin: 0px auto;
        }
      }
    }

    dd.left {
      .score,
      strong {
        text-align: right;
      }
    }
  }

  //页面左侧区域
  .body_left {
    float: left;
    width: calc(100% - 350px);
    height: auto;
    overflow: hidden;

    .iframe-box {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      clear: both;
      width: 100%;
      height: 5.45rem;
      overflow: hidden;
      background-color: #000;
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;

      iframe {
        display: block;
        width: 8rem;
        height: 4.05rem;
        overflow: hidden;
        border: none;
      }
    }

    //[页面通用]正文中的选项卡标题
    .option_tags {
      display: flex;
      justify-content: center;
      clear: both;
      width: 100%;
      height: 50px;
      overflow: hidden;
      background-color: #f9f9fb;
      border-bottom: 1px solid #f0f0f0;
      margin-top: 10px;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -o-user-select: none;
      -ms-user-select: none;

      li {
        width: 1.5rem;
        height: 50px;
        line-height: 50px;
        overflow: hidden;
        font-size: 0.16rem;
        color: #333;
        text-align: center;
        position: relative;
        cursor: pointer;

        &:hover {
          color: #02a8a2;
          font-weight: bold;
        }
      }

      li.active {
        color: #02a8a2;
        font-weight: bold;

        &::before {
          content: "";
          display: block;
          clear: both;
          width: 0.2rem;
          height: 0.04rem;
          overflow: hidden;
          border-radius: 0.1rem;
          background-color: #02a8a2;
          margin: 0 auto;
          position: absolute;
          z-index: 2;
          left: 0;
          right: 0;
          bottom: 0.01rem;
        }
      }
    }

    .tags_content {
      clear: both;
      width: 100%;
      min-height: 400px;
      overflow: hidden;
      background-color: #fff;
      border-bottom-left-radius: 0.1rem;
      border-bottom-right-radius: 0.1rem;
      box-sizing: border-box;
      padding-bottom: 20px;
    }
  }

  //页面右侧区域
  .body_right {
    float: right;
    width: 340px;
    height: 5.46rem;
    overflow: hidden;
    background-color: #fff;
    border-radius: 0.05rem;
    border: 1px solid #eee;
    box-sizing: border-box;

    //滚动公告区
    .notice_scroll {
      display: flex;
      justify-content: space-between;
      clear: both;
      width: 100%;
      height: 40px;
      overflow: hidden;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;

      dt {
        flex-shrink: 0;
        width: 35px;
        height: 100%;
        overflow: hidden;
        background-color: #fff;
        padding: 11px 5px;
        box-sizing: border-box;
        cursor: pointer;

        img {
          display: block;
          float: right;
          height: 100%;
        }
      }

      dt.arrow {
        width: 20px;
        padding: 11px 0px;
        img {
          float: none;
          height: 6px;
          margin: 6px auto;
        }
      }

      dd {
        flex-shrink: 0;
        width: 285px;
        height: 100%;
        line-height: 39px;
        overflow: hidden;
        font-size: 14px;
        color: #666;
      }
    }

    //右侧选项卡及对应的列表内容
    .option_title {
      clear: both;
      width: 100%;
      height: 32px;
      line-height: 32px;
      overflow: hidden;
      background-color: #f0f0f0;

      li {
        float: left;
        // width: 113px;
        width: 100%;
        height: 100%;
        overflow: hidden;
        font-size: 14px;
        color: #000;
        text-align: center;
        cursor: pointer;
      }

      li.active {
        // background-color: #fff;
      }
    }
  }
}
</style>
